import { useState, useEffect, useContext } from "react";
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { useAppStore } from "../stores/RootStore";
import { apiBaseUrl, siteApiBaseUrl } from "../config/publicConfig";

interface CurrentUserState {
  currentSite: {
    subdomain: string;
  };
}

interface Options {
  method?: string;
  headers?: {
    Accept: string;
    "Content-Type": string;
    Authorization: string;
  };
  data?: any;
}

interface ResponseData {
  attributes: any;
  status: string;
}

interface Response {
  data: ResponseData;
  meta?: any;
}

interface FetchState {
  response: Response | null;
  isLoading: boolean;
  error: any;
  meta: any;
}

type FetchFunction = (options?: Options) => void;

export const useFetch = (
  url: string,
  isBase: boolean = false,
  isImage: boolean = false
): [FetchState, FetchFunction] => {
  const store = useAppStore();

  const currentSubdomain: string = store.currentSite ? store.currentSite.subdomain : "";
  const requestUrl = isBase ? apiBaseUrl(url) : siteApiBaseUrl(currentSubdomain, url);
  const baseOption: AxiosRequestConfig = {
    method: "GET",
    headers: isImage
      ? {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${
            localStorage.getItem("weld-jwt") ? JSON.parse(localStorage.getItem("weld-jwt")!).token : null
          }`,
        }
      : {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${
            localStorage.getItem("weld-jwt") ? JSON.parse(localStorage.getItem("weld-jwt")!).token : null
          }`,
        },
  };
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);
  const [response, setResponse] = useState<Response | null>(null);
  const [meta, setMeta] = useState<any>(null);
  const [options, setOptions] = useState<Options>({});

  const doFetch: FetchFunction = (options = {}) => {
    // @ts-ignore
    setOptions({ ...baseOption, ...options });
    setIsLoading(true);
  };

  useEffect(() => {
    let skipGetResponseAfterDestroy: boolean = false;
    if (!isLoading) {
      return;
    }
    setIsLoading(true);
    axios(requestUrl, options)
      .then((res: AxiosResponse) => {
        if (!skipGetResponseAfterDestroy) {
          if (res.status == 204) {
            // @ts-ignore
            setResponse({ data: { status: "ok" } });
          } else {
            setResponse(res.data);
            if (res.data.meta) {
              setMeta(res.data.meta);
            }
          }
          setIsLoading(false);
        }
      })
      .catch((err) => {
        if (!skipGetResponseAfterDestroy) {
          if (err.response) {
            setError(err.response.data);
          }
          setIsLoading(false);
        }
      });

    return () => {
      skipGetResponseAfterDestroy = true;
    };
  }, [isLoading]);

  return [{ response, isLoading, error, meta }, doFetch];
};
